(() => {
  const init = (root) => {
    if (root.dataset.ocpMobileBuyReady === "true") return;

    const bar = root.querySelector("[data-ocp-mobile-buy]");
    const variantsScript = root.querySelector("[data-ocp-variants]");
    if (!bar || !variantsScript) return;

    root.dataset.ocpMobileBuyReady = "true";

    let variants = [];
    try {
      variants = JSON.parse(variantsScript.textContent || "[]");
    } catch {
      variants = [];
    }

    const optionInputs = [...root.querySelectorAll("[data-ocp-option-input]")];
    const variantId = root.querySelector("[data-ocp-variant-id]");
    const price = bar.querySelector("[data-ocp-mobile-price]");
    const compare = bar.querySelector("[data-ocp-mobile-compare]");
    const addButton = bar.querySelector("[data-ocp-mobile-add]");
    const checkout = bar.querySelector("[data-ocp-mobile-checkout]");
    const buyNow = bar.querySelector("[data-ocp-buy-now]");
    const form = addButton?.closest("form");

    let currentAvailable = false;

    const selectedOptions = () => {
      const positions = [...new Set(optionInputs.map((input) => Number(input.dataset.optionPosition)))].sort((a, b) => a - b);
      return positions.map((position) => {
        return root.querySelector(`[data-ocp-option-input][data-option-position="${position}"]:checked`)?.value || "";
      });
    };

    const selectedVariant = () => {
      if (!optionInputs.length) {
        return variants.find((variant) => String(variant.id) === String(variantId?.value)) || variants[0];
      }

      const selected = selectedOptions();
      return variants.find((variant) => {
        return variant.options.length === selected.length && variant.options.every((value, index) => value === selected[index]);
      });
    };

    const syncCheckout = () => {
      if (!checkout) return;

      checkout.setAttribute("aria-disabled", String(!currentAvailable));
      checkout.querySelectorAll("button").forEach((button) => {
        if (!currentAvailable) {
          button.dataset.ocpMobileForcedDisabled = "true";
          button.disabled = true;
        } else if (button.dataset.ocpMobileForcedDisabled === "true") {
          button.disabled = false;
          delete button.dataset.ocpMobileForcedDisabled;
        }
      });
    };

    const sync = (variant = selectedVariant()) => {
      const available = Boolean(variant?.available);
      currentAvailable = available;
      bar.classList.toggle("is-unavailable", !available);

      if (!variant) {
        if (addButton) {
          addButton.disabled = true;
          addButton.textContent = addButton.dataset.unavailableLabel || "Unavailable";
        }
        syncCheckout();
        return;
      }

      if (variantId) {
        variantId.value = variant.id;
        variantId.dispatchEvent(new Event("change", { bubbles: true }));
      }

      if (price) price.textContent = variant.price;
      if (compare) {
        compare.textContent = variant.compareAtHigher ? variant.compareAt || "" : "";
        compare.classList.toggle("is-hidden", !variant.compareAtHigher);
      }

      if (addButton) {
        addButton.disabled = !available;
        addButton.textContent = available
          ? addButton.dataset.addLabel || "Add to cart"
          : addButton.dataset.soldLabel || "Sold out";
      }

      syncCheckout();
    };

    optionInputs.forEach((input) => input.addEventListener("change", () => sync()));
    document.addEventListener("ottuni:variant-change", (event) => sync(event.detail?.variant));

    form?.addEventListener("submit", async (event) => {
      if (buyNow && event.submitter === buyNow && !form.reportValidity()) {
        event.preventDefault();
        return;
      }
      if (event.submitter !== addButton) return;

      event.preventDefault();
      if (!currentAvailable || addButton.disabled) return;

      addButton.disabled = true;
      addButton.setAttribute("aria-busy", "true");

      try {
        const formData = new FormData(form);
        const sectionIds = [...new Set(
          [...document.querySelectorAll("cart-items-component[data-section-id]")]
            .map((component) => component.dataset.sectionId)
            .filter(Boolean)
        )];

        if (sectionIds.length) {
          formData.set("sections", sectionIds.join(","));
          formData.set("sections_url", window.location.pathname);
        }

        const response = await fetch(Theme.routes.cart_add_url, {
          method: "POST",
          headers: {
            Accept: "application/json",
            "X-Requested-With": "XMLHttpRequest"
          },
          body: formData
        });
        const added = await response.json();

        if (!response.ok || added.status) {
          throw new Error(added.description || added.message || "Unable to add this item to the cart.");
        }

        const cartResponse = await fetch(`${Theme.routes.cart_url}.js`, { headers: { Accept: "application/json" } });
        const cart = await cartResponse.json();

        document.dispatchEvent(new CustomEvent("cart:update", {
          bubbles: true,
          detail: {
            resource: cart,
            sourceId: form.id,
            data: {
              source: "ottuni-mobile-buy",
              itemCount: Number(formData.get("quantity")) || 1,
              variantId: String(formData.get("id") || ""),
              sections: added.sections || {}
            }
          }
        }));
        window.dispatchEvent(new CustomEvent("ottuni:cart-change", { detail: { cart } }));
      } catch (error) {
        console.error(error);
      } finally {
        addButton.removeAttribute("aria-busy");
        addButton.disabled = !currentAvailable;
      }
    });

    if (checkout) {
      new MutationObserver(syncCheckout).observe(checkout, { childList: true, subtree: true });
    }

    sync();
  };

  const scan = (scope = document) => {
    scope.querySelectorAll("[data-ottuni-chair-main]").forEach(init);
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => scan(), { once: true });
  } else {
    scan();
  }

  document.addEventListener("shopify:section:load", (event) => scan(event.target));
})();
